import * as React from "react";
import { SVGProps } from "react";

const ChevronDownSVG: React.FC<SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.57 5.125a1.47 1.47 0 0 0-.107 2.074L10.91 18.77a1.47 1.47 0 0 0 2.18 0L23.537 7.2a1.47 1.47 0 0 0-.107-2.074 1.47 1.47 0 0 0-2.075.105L12 15.594 2.645 5.23A1.47 1.47 0 0 0 .57 5.125Z"
    />
  </svg>
);

export default ChevronDownSVG;
